import React from "react";

import styles from "components/v2/common/IndiceDeConfiance/IndiceDeConfiance.module.css";

export default function IndiceDeConfiance({
  t,
  value,
  popover,
}: {
  t: any;
  value: number | string;
  popover?: JSX.Element;
}) {
  return (
    <div className={styles.indice__confiance__container}>
      {parseInt(`${value}`) ? (
        <>
          <p className={styles.indice__confiance__text}>
            {`${t("Indice de confiance")}`}
          </p>
          <div className={styles.indice__confiance__list__container}>
            <ul className={styles.indice__confiance__list}>
              {Array.from({ length: parseInt(`${value}`) }, (_, i) => i).map(
                (item, index) => {
                  return (
                    <li
                      key={index}
                      className={`${styles.indice__confiance} ${styles.indice__confiance__green}`}
                    ></li>
                  );
                }
              )}
              {Array.from(
                { length: 5 - parseInt(`${value}`) },
                (_, i) => i
              ).map((item, index) => {
                return (
                  <li
                    key={5 - index}
                    className={`${styles.indice__confiance} ${styles.indice__confiance__grey}`}
                  ></li>
                );
              })}
            </ul>
          </div>
        </>
      ) : null}
    </div>
  );
}
